// Glass-and-obsidian palette (GDD §14.5). Every color reference goes through
// this module so palette tweaks are one-place changes.

export const theme = {
  /** Deep obsidian black with the faintest cool undertone. */
  background: 0x070a10,
  /** Grid lines: thin, semi-transparent, etched into back-lit glass. */
  gridLine: 0x3a4a66,
  gridLineAlpha: 0.38,
  /** Pellets: bright, crystalline, lit from within. */
  pellet: 0xcfe8ff,
  pelletHalo: 0x9fd0ff,
  /** Bouncers: matte, solid, deliberately unglassy. */
  bouncer: 0x2a2f3a,
  bouncerEdge: 0xb8c0d0,
  /** HUD text. */
  text: '#e6ecff',
  textDim: '#8b96ad',
} as const;
